// Modules
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";
// Material-UI
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
// Components
import { Locales, NavigationScroll } from "../UITemplate";
// Styles
import themes from "../UITemplate/themes";

const MainLayout = dynamic(() => import("../UITemplate/layout/MainLayout"), { ssr: false });

function AppLayout({ children, mainLayout }) {
    const customization = useSelector(state => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <Locales>
                    <NavigationScroll>{mainLayout ? <MainLayout>{children}</MainLayout> : children}</NavigationScroll>
                </Locales>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

AppLayout.propTypes = {
    children: PropTypes.node.isRequired,
    mainLayout: PropTypes.bool
};

export default AppLayout;
